import BoardImage from './BoardImage';
import { useConfig } from '../../ConfigContext';
import Overlay from './Overlay';
import { useEffect, useRef, useState } from 'react';
import OverlayHorizontal from './OverlayHorizontal';
import { glassTypes } from '../../../glassConsts';

export default function Preview({ Cropper }) {
  const { containerRef, general, size } = useConfig();

  const [isLoaded, setIsLoaded] = useState(false);
  window.addEventListener('load', () => setIsLoaded(true), { once: true });

  useEffect(() => {
    if (document.readyState === 'complete') setIsLoaded(true);
  }, []);

  const thisRef = useRef(null);
  const [localSize, setLocalSize] = useState({ width: 0, height: 0 });
  const updateSize = () => {
    if (thisRef.current) {
      setLocalSize({
        width: thisRef.current.clientWidth,
        height: thisRef.current.clientHeight,
      });
    }
  };

  useEffect(() => {
    setTimeout(() => updateSize(), 200);
  }, [
    general.glassType,
    general.selectedCarouselCropIndex,
    isLoaded,
    general.orientationHorizontal,
    window.innerWidth,
  ]);

  return (
    <div
      style={{
        margin: `0 auto`,
      }}
    >
      <div
        ref={containerRef}
        className={`preview${general.orientationHorizontal && ['classic', 'pair', 'multiple'].includes(general.glassType) ? '__horizontal' : ''}`}
        id="deska"
        style={{
          margin: `0 auto`,
        }}
      >
        <BoardImage />
        {isLoaded && general.orientationHorizontal && (
          <OverlayHorizontal
            Cropper={Cropper}
            thisRef={thisRef}
            localSize={localSize}
          />
        )}
        {isLoaded &&
          (!general.orientationHorizontal ||
            general.glassType === 'music' ||
            general.glassType === 'socials') && (
            <Overlay
              Cropper={Cropper}
              thisRef={thisRef}
              localSize={localSize}
            />
          )}
      </div>
    </div>
  );
}
